import React from "react";
import { BackArrow } from "themes/Icon";
import ButtonComp from "themes/elements/Button";
import style from "../../../CreateNotification/create_noti.module.scss";

function Header(props) {
  const {
    handleClose,
    isEdit,
    myNewsArticle,
    newsStatus,
    isLoading,
    handleTabChange,
    checkDraftValidation,
    checkValidation,
  } = props;

  return (
    <>
      <div
        className={`flex align-center justify-between w-full ${style["header-container"]}`}
      >
        <div className="flex align-center gap-2">
          <span onClick={handleClose} className="pointer">
            <BackArrow />
          </span>
          <h2 className="page-title">
            {isEdit ? "Edit news article" : "Create news article"}
          </h2>
        </div>
        <div className="flex align-center wrap gap-4">
          <ButtonComp onClick={handleClose} variant="secondary">
            Cancel
          </ButtonComp>
          {!myNewsArticle && (
            <ButtonComp
              loading={newsStatus === 0 ? isLoading : false}
              onClick={() => {
                handleTabChange("5");
                checkDraftValidation();
              }}
              variant="secondary"
            >
              Save as draft
            </ButtonComp>
          )}
          <ButtonComp
            loading={newsStatus === 4 || newsStatus === 1 ? isLoading : false}
            onClick={() => {
              checkValidation();
            }}
          >
            {myNewsArticle ? "Publish" : "Submit for approval"}
          </ButtonComp>
        </div>
      </div>
    </>
  );
}

export default Header;
